import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud-service';
import { Observable } from 'rxjs';
import { Tarifario } from '../interfaces/utilidades/tarifario.interface';

@Injectable({
  providedIn: 'root'
})
export class TarifarioService extends CrudService<any> {
  private baseUrl: string;

  constructor(http: HttpClient) {
    super(http, 'https://camposdeportivos.muninuevochimbote.gob.pe/api/tarifarios');
    this.baseUrl = 'https://camposdeportivos.muninuevochimbote.gob.pe/api/tarifarios';
  }

  updateTarifa(id: number, tarifa: Partial<Tarifario>): Observable<Tarifario> {
    return this.http.patch<Tarifario>(`${this.baseUrl}/${id}`, tarifa);
  }
}
